<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>{{ title }}</title>
    <path fill="#2F477C" d="M4 5v13h17V5zm10 2v9h-3V7zM6 7h3v9H6zm13 9h-3V7h3z" />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: '24',
    },
    title: {
      type: String,
      default: 'View Menu',
    },
  },
};
</script>
